import { useNavigate } from "react-router-dom";
import logo from "../../images/logo.png";

const Header = () => {
  const navigate = useNavigate();

  return (
    <header id="header">
      <div className="logo" onClick={() => navigate("/")}>
        <img src={logo} alt="eqqual logo" />
      </div>
      <div id="menu_button"></div>
      <nav id="navigation"></nav>
    </header>
  );
};

export default Header;
